import React from 'react';
import { BasketIcon } from '../BasketIcon';

/**
 * Inline outlined basket name chip for Due question headings.
 * Presentational only — not interactive, not focusable.
 */
const BasketNameChip = ({ name }) => {
  if (!name) return null;

  return (
    <span className="inline-flex max-w-full -translate-y-px items-center gap-1.5 align-baseline rounded-lg border-2 border-neutral-900 bg-white px-2.5 text-[0.9em] font-semibold leading-[1.35] text-neutral-900">
      <span
        className="shrink-0 scale-75 [&_svg]:mr-0 [&_svg]:h-5 [&_svg]:w-5"
        aria-hidden="true"
      >
        <BasketIcon />
      </span>
      <span className="min-w-0 break-words">{name}</span>
    </span>
  );
};

export default BasketNameChip;
